import { Banner, BannerProps, Typography, Stack, Container } from '@optimus-web/core';
import { AssistantCommandResult, AssistantResultType } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

interface CommandResultBoxProps {
    commandResult: AssistantCommandResult;
}

export const AssistantCommandBox = ({ commandResult }: CommandResultBoxProps) => {
    const getBannerVariant = (result: AssistantCommandResult) => {
        switch (result.responseType) {
            case AssistantResultType.Ok:
                return result.isSuccess ? 'success' : 'info';
            case AssistantResultType.Invalid:
                return 'warning';
            case AssistantResultType.NotFound:
            case AssistantResultType.Unauthorized:
            case AssistantResultType.Unexpected:
                return 'error';
            default:
                return 'info';
        }
    };

    const getBanner = (result: AssistantCommandResult) => {
        const variant = getBannerVariant(result);
        const primaryText =
            variant !== 'error' ? <>{result.message}</> : <LocalizedText textKey={TextKey.GenericErrorTitle} />;
        const secondaryText = variant !== 'error' ? undefined : <LocalizedText textKey={TextKey.GenericErrorMessage} />;
        const props: BannerProps = {
            primaryText: (
                <Typography textStyle="bodyMediumStrong" as="div">
                    {primaryText}
                </Typography>
            ),
            secondaryText,
            variant,
            wordBreak: 'break-word',
        };

        return <Banner {...props} />;
    };

    return (
        <Container padding="100">
            <Stack vertical spacing="200">
                {getBanner(commandResult)}
            </Stack>
        </Container>
    );
};
